module.exports = __webpack_public_path__ + "static/media/instructor-5.cc4bd549.png";